<i18n>
{
  "en": {
    "get_started": "Get Started",
    "section2_headline": "The best way to start 24/7 routine tasks",
    "section2_subheadline": "cloud-based gaming assistant robot",
    "section3_headline": "24/7 auto gaming has never been easier",
    "section3_subheadline": "Kick-start your robot today",
    "section4_about_title": "About",
    "section4_about_content": "is a cloud-based 24/7 service for gaming routine task assistant robot.",
    "section4_resource_title": "Resources",
    "section4_resource_content_privacy_policy": "Privacy Policy",
    "section4_resource_content_terms_of_service": "Terms of Service",
    "section4_contact_title": "Contacts",
    "apply_free_trial1": "Unlimited one hour free trial!",
    "apply_free_trial2": "No credit cards required!!",
    "apply_free_trial3": "Try for free now!!!",
    "robotmon": "Robotmon",
    "christmas_event_title": "XRobotmon x Disney Tsum Tsum",
    "christmas_event": "5th Anniversary Christmas Sale",
    "christmas_event_p1": "Buy 1 year, get 6 months free",
    "christmas_event_p2": "Only $14.66 per month"
  },
  "zhHant": {
    "get_started": "立刻開始",
    "section2_headline": "最佳 24/7 全天候掛機解決方案",
    "section2_subheadline": "雲端遊戲助手/腳本/輔助/外掛",
    "section3_headline": "24/7 全自動化掛機從未如此容易",
    "section3_subheadline": "現在就啟動你的助手吧",
    "section4_about_title": "關於我們",
    "section4_about_content": "是基於雲端的 24/7 全天候自動化掛機完美解決方案",
    "section4_resource_title": "資源",
    "section4_resource_content_privacy_policy": "隱私權保護聲明",
    "section4_resource_content_terms_of_service": "服務條款",
    "section4_contact_title": "聯絡我們",
    "apply_free_trial1": "無限次數免費試用1小時",
    "apply_free_trial2": "無需綁定信用卡",
    "apply_free_trial3": "馬上開始免費試用吧！",
    "robotmon": "Robotmon",
    "christmas_event_title": "XRobotmon x Disney Tsum Tsum",
    "christmas_event": "五週年聖誕限時優惠中",
    "christmas_event_p1": "買一年方案送半年",
    "christmas_event_p2": "每月只要 NT466"
  },
  "ja": {
    "get_started": "今すぐスタート",
    "section2_headline": "ルーチンタスクを24時間こなす、最高のパートナー",
    "section2_subheadline": "クラウド型ゲーム ロボット",
    "section3_headline": "24時間のゲーム自動実行を簡単設定で",
    "section3_subheadline": "今日からロボットでゲームを始めよう",
    "section4_about_title": "Xロボットモン とは",
    "section4_about_content": "はルーチン タスクを支援する、24時間稼働のクラウド型ゲームロボットです。",
    "section4_resource_title": "リソース",
    "section4_resource_content_privacy_policy": "プライバシー規約",
    "section4_resource_content_terms_of_service": "利用規約",
    "section4_contact_title": "お問い合わせ",
    "apply_free_trial1": "無料トライアルご利用回数制限なし",
    "apply_free_trial2": "クレジットカード不要",
    "apply_free_trial3": "今すぐ試してみよう！",
    "robotmon": "ロボットモン",
    "christmas_event_title": "Xロボットモン5周年 x ツムツム",
    "christmas_event": "クリスマスセール開催",
    "christmas_event_p1": "ライセンス360日を購入後､",
    "christmas_event_p2": "180日延長される特典ゲット"
  },
    "ko": {
    "get_started": "바로 시작",
    "section2_headline": "24시간 자동으로 작동합니다",
    "section2_subheadline": "클라우드 기반 자동 매크로",
    "section3_headline": "24시간 자동 매크로로 게임이 쉬워집니다.",
    "section3_subheadline": "지금 바로 시작해보세요",
    "section4_about_title": "회사 소개",
    "section4_about_content": "클라우드 기반 24시간 자동 매크로",
    "section4_resource_title": "리소스",
    "section4_resource_content_privacy_policy": "개인 정보 정책",
    "section4_resource_content_terms_of_service": "이용 약관",
    "section4_contact_title": "문의",
    "apply_free_trial1": "하루에 한시간 무료 체험할 수 있습니다",
    "apply_free_trial2": "결제 카드를 등록하지 않고",
    "apply_free_trial3": "지금 바로 무료로 체험해보세요!",
    "robotmon": "Robotmon",
    "christmas_event_title": "XRobotmon x Disney Tsum Tsum",
    "christmas_event": "5주년 기념 크리스마스 기간 한정 혜택",
    "christmas_event_p1": "1년 플랜 구매 시 반년 추가 무료 제공",
    "christmas_event_p2": "한 달에 단 $14.66"
  }
}
</i18n>

<template>
  <div>
    <section>
      <div class="carousel-img-container" v-if="imageItems && imageItems.length > 0">
        <v-carousel height="auto">
          <v-carousel-item v-for="(item, i) in imageItems" :key="i" :src="item.src"></v-carousel-item>
        </v-carousel>
      </div>


      <v-container>
        <v-layout column wrap align-center justify-center>
          <img v-if="!imageItems || imageItems.length === 0" v-bind:src="robotmonLogoUrl" width="256" height="256" />
          <h1 class="mb-2 display-1 text-xs-center">
            <XRobotmonTitle />
          </h1>
          <div class="subheading mb-3 text-xs-center">Powered by {{ $t('robotmon') }}</div>
          <v-btn class="blue lighten-2 mt-5" dark large to="/login">{{ $t('get_started') }}</v-btn>
        </v-layout>
      </v-container>
    </section>

    <section class="my-5">
      <v-layout row wrap>
        <v-flex xs0 sm0 md1></v-flex>
        <v-flex xs12 sm6 md5>
          <img :src="intro1" width="100%" height="100%" />
        </v-flex>
        <v-flex xs12 sm6 md5>
          <img :src="intro2" width="100%" height="100%" />
        </v-flex>
        <v-flex xs0 sm0 md1></v-flex>
      </v-layout>
    </section>

    <SupportGames />

    <section class="my-5">
      <v-container>
        <v-layout column wrap align-center justify-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">{{ $t('section2_headline') }}</h2>
              <span class="subheading">{{ $t('section2_subheadline') }}</span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 v-for="(why, whyId) in whyChooseList" :key="whyId">
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">{{ why.icon }}</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">
                      {{ why.title[$i18n.locale] }}
                    </div>
                  </v-card-title>
                  <v-card-text>{{ why.content[$i18n.locale] }}</v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section>
      <v-parallax v-bind:src="robotmonLogoUrl">
        <v-layout column align-center justify-center>
          <div class="headline black--text mb-3 text-xs-center">
            {{ $t('section3_headline') }}
          </div>
          <em class="black--text">{{ $t('section3_subheadline') }}</em>
          <v-btn class="blue lighten-2 mt-5" dark large to="/login">{{ $t('get_started') }}</v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <SupportGames />

    <section class="my-5">
      <v-container>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">{{ $t('section4_about_title') }}</div>
              </v-card-title>
              <v-card-text>
                <XRobotmonTitle />
                {{ $t('section4_about_content') }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">{{ $t('section4_contact_title') }}</div>
              </v-card-title>
              <ContactInfo></ContactInfo>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="60000" color="info">
      {{ $t('apply_free_trial1') }} <br />
      {{ $t('apply_free_trial2') }} <br />
      {{ $t('apply_free_trial3') }}
      <v-btn dark flat small @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import assetMisc from '../assets/misc';
import XRobotmonTitle from '../components/XRobotmonTitle';
import ContactInfo from '../components/ContactInfo';
import SupportGames from '../components/SupportGames.vue';

export default {
  name: 'intro',
  components: {
    XRobotmonTitle,
    ContactInfo,
    SupportGames,
  },
  data: () => {
    return {
      snackbar: true,
      robotmonLogoUrl: assetMisc.robotmonLogoUrl,
      christmasImgUrl: assetMisc.christmasImgUrl,
      //intro1: assetMisc.intro1,
      //intro2: assetMisc.intro2,
      whyChooseList: [
        {
          icon: 'mdi-emoticon-outline',
          title: {
            en: 'Ease-Of-Use',
            zhHant: '易於使用',
            ja: '便利',
            ko: '사용하기 쉽습니다',
          },
          content: {
            en: 'Root? Emulator? Just forget all of the complex know-how. All you need to do is just simply click start button.',
            zhHant:
              '不再須要煩惱 Root或模擬器等惱人的技術問題！你唯一需要做的就是按下啟動按鈕 。沒錯！一切就是這麼簡單。',
            ja: 'ロボットやエミュレーターなどの複雑な知識は要りません。「今すぐスタート」ボタンを押して、ゲームを始めましょう。',
            ko: '루팅이나 에뮬레이터 등 다른 프로그램을 실행하지 않아도 됩니다.  시작 버튼을 눌러 시작하세요!',
          },
        },
        {
          icon: 'mdi-cloud-outline',
          title: {
            en: 'Cloud-based',
            zhHant: '基於雲端',
            ja: 'クラウド型',
            ko: '클라우드 기반 매크로 입니다',
          },
          content: {
            en: 'You do not need your mobile anymore. Now, you can close the phone screen while you are sleeping, without light pollution. You deserve a good night.',
            zhHant:
              '你不再需要使用自己的設備或另外找尋設備了。 現在開始，你可以安心關閉手機螢幕，睡覺時不再有光害，不再煩惱情侶、夫妻間失和問題。 你值得睡的更好！',
            ja: 'クラウドで指示したら、もうスマホは不要です。スマホの画面を消して、ぐっすり睡眠をとってください。',
            ko: '클라우드 기반으로, 스마트폰을 키고 있을 필요가 없습니다.',
          },
        },
        {
          icon: 'mdi-security',
          title: {
            en: 'Safe and Secure',
            zhHant: '安全且加密',
            ja: '安全・安心',
            ko: '안전하게 데이터를 지켜드립니다',
          },
          content: {
            en: 'All connections are encrypted. All account and password infomation are also encrypted. In short, everything is encrypted. No one can access anything, even the staff.',
            zhHant: '所有連線全程加密。所有帳號密碼使用最高強度加密演算法。我們比你更注重安全性！',
            ja: '通信やアカウント、パスワードを含む全ての情報を暗号化します。弊社スタッフを含め、誰もあなたの情報を見ることはできません。',
            ko: '모든 계정의 비밀번호는 최고강도 암호화 알고리즘을 사용합니다. 당신의 암호화 데이터 안정성을 중요시 합니다.',
          },
        },
        {
          icon: 'mdi-apps',
          title: {
            en: 'Parallel/Multiple Accounts',
            zhHant: '平行/多開帳戶',
            ja: 'ツム複数アカウント同時利用',
            ko: '동시 작동이 가능합니다',
          },
          content: {
            en: 'You can run parallel apps and games. It allows you to run the same game while logged in from two different accounts. Or even multiple devices simultaneously.',
            zhHant:
              '你可以同時執行多個遊戲。不論是同一個遊戲不同帳號，或是完全不同的遊戲，你愛開幾個就開幾個，不再受限於現有的設備數量。',
            ja: '複数のアプリやゲームを同時に実行できるため、2 つのアカウントや複数のデバイスを使って１つのゲームへの同時ログインが可能。',
            ko: '여러개의 게임을 동시에 실행 할 수 잇습니다. 같은 게임이 다른 계정이든, 아니면 완전히 다른 게임이든 간에, 원하는 만큼 가능합니다.',
          },
        },
        {
          icon: 'mdi-cellphone-link',
          title: {
            en: 'Cross-Platform',
            zhHant: '跨裝置跨平台',
            ja: 'クロスプラットフォーム',
            ko: '편리하게 제어 할 수 있습니다',
          },
          content: {
            en: 'You can monitor all supported Android apps and games from your Windows PC, Laptop, Linux PC, Laptop, Mac PC, Laptop and Android, iOS devices anytime, anywhere.',
            zhHant:
              '隨時隨地用你的手機、平板或電腦來啟動/關閉掛機，或是觀看當下遊戲狀態。 出門時，再也不用再為了連不到家裡的電腦煩惱。完完全全做遊戲真正的主人！',
            ja: 'Windows、Linux、Macのデスクトップやノート、Androidや iOSデバイスを含め、Androidアプリやゲームをサポートしている全てのデバイスを使い、いつでもどこでもモニタリングが可能。',
            ko: '언제 어디서나 스마트폰, 태블릿, PC로 작동을 실행시키거나 중지할 수 있습니다. 집밖에서도 쉽게 제어할 수 있습니다.',
          },
        },
        {
          icon: 'mdi-power-plug-off',
          title: {
            en: 'Power saving',
            zhHant: '節省電力',
            ja: '省エネ',
            ko: '전력을 절약할 수 있습니다',
          },
          content: {
            en: 'You do not need to pay electricity bill for 24/7 gaming.',
            zhHant: '小資一族只能對不斷上漲的電費嘆息，電腦整天開著電費更是驚人！現在，你完全可以省下這一切。',
            ja: '24 時間ゲームをしても電気代を抑えられます。',
            ko: '스마트폰이나 PC를 키고 있을 필요가 없습니다.',
          },
        },
        {
          icon: 'mdi-wifi-off',
          title: {
            en: 'Network free',
            zhHant: '無需網路',
            ja: 'クラウドで指示したあとはインターネット不要です',
            ko: '인터넷 걱정을 하지 않아도 됩니다',
          },
          content: {
            en: 'Network stability will no long effect your gaming progress!',
            zhHant: '一回家發現網路斷線？從此不再擔心網路的不穩定導致掛機效率大打折扣了。',
            ja: '不安定なネットワークによりゲームの進捗に影響がでることはありません。',
            ko: '작동이후 인터넷없이 자동으로 작동됩니다.',
          },
        },
        {
          icon: 'mdi-timer',
          title: {
            en: 'Quick start',
            zhHant: '極速啟動',
            ja: 'クイック スタート',
            ko: '빠르게 시작합니다.',
          },
          content: {
            en: 'From config to launch, only 10 seconds!!',
            zhHant: '十秒鐘從設定到開始掛機，試了就知道！',
            ja: '設定時間はたったの10 秒!',
            ko: '10초만에 설정을 마치고, 시작할 수 있습니다.',
          },
        },
        {
          icon: 'mdi-youtube-tv',
          title: {
            en: 'Live streaming',
            zhHant: '實時監控',
            ja: 'ライブ ストリーミング',
            ko: '실시간 모니터링 생방송을 지원합니다.',
          },
          content: {
            en: 'Monitor your robot in realtime, anywhere.',
            zhHant: '隨時隨地無時差監控你的助手。',
            ja: '場所を問わずリアルタイムでロボットの実行状態をモニタリングできます。',
            ko: '언제 어디서나 실시간으로 모니터링 하세요.',
          },
        },
      ],
    };
  },
  computed: {
    intro1() {
      switch (this.$i18n.locale) {
        case 'zhHant':
          return assetMisc.intro1zh;
        case 'ja':
          return assetMisc.intro1ja;
        case 'ko':
          return assetMisc.intro1ko;
        case 'en':
          return assetMisc.intro1en;
        default:
          return assetMisc.intro1en;
      }
    },
    intro2() {
      switch (this.$i18n.locale) {
        case 'zhHant':
          return assetMisc.intro2zh;
        case 'ja':
          return assetMisc.intro2ja;
        case 'ko':
          return assetMisc.intro2ko;
        case 'en':
          return assetMisc.intro2en;
        default:
          return assetMisc.intro2en;
      }
    },
    imageItems() {
      switch (this.$i18n.locale) {
        case 'zhHant':
          return [];
        case 'ja':
          return [];
        case 'ko':
          return [];
        case 'en':
          return [];
        default:
          return [];
      }
    }
  },
  methods: {
    privacyPolicy() {
      this.$router.push(`/privacy-policy`);
    },
    termsOfService() {
      this.$router.push(`/terms-of-service`);
    },
  },
};
</script>

<style>
.carousel-img-container {
  position: relative;
  display: flex;
  /* width: 600px; */
  justify-items: center;
  justify-content: center;
  align-items: center;
  margin: auto;
}

.v-carousel__controls {
  display: none;
}

.v-carousel {
  width: 100%;
  max-width: 600px;
}

@media (max-width: 600px) {
  .v-carousel {
    width: 100%;
  }

  .v-carousel {
    width: 100%;
  }
}
</style>
